// generated from 45_003 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const workflowEnteredVariationFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("workflow_entered_variation_filter"),
  comparison_key: z.enum([
    "8", // 32_610 (72.46%)
    "7", // 12_393 (27.54%)
  ]),
  display_name: z.string(),
  // undefined: 44_993 (99.98%), defined 10 (0.02%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 19_374 (43.05%), defined 25_629 (56.95%)
  raw_value: z
    .object({
      prefilter_value: common.objectId,
      value: z.union([
        // string samples: 25_619 (99.96%)
        common.objectId,
        // object samples: 10 (0.04%)
        z.object({
          variation_nst: z.int().min(0),
          workflow_id: common.objectId,
        }),
      ]),
    })
    .optional(),
  value: z.object({
    id: z.union([
      // string samples: 44_993 (99.98%)
      common.objectId,
      // object samples: 10 (0.02%)
      z.object({
        variation_nst: z.int().min(0),
        workflow_id: common.objectId,
      }),
    ]),
    pre_filter_value: z.object({
      // undefined: 10 (0.02%), defined 44_993 (99.98%)
      // true 14_360 (31.92%), false 30_633 (68.08%)
      expired: z.boolean().optional(),
      id: common.objectId,
      value: z.string(),
    }),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
